import _classCallCheck from '../../../../node_modules/@babel/runtime/helpers/classCallCheck.es.js';
import _createClass from '../../../../node_modules/@babel/runtime/helpers/createClass.es.js';
import _inherits from '../../../../node_modules/@babel/runtime/helpers/inherits.es.js';
import _possibleConstructorReturn from '../../../../node_modules/@babel/runtime/helpers/possibleConstructorReturn.es.js';
import _getPrototypeOf from '../../../../node_modules/@babel/runtime/helpers/getPrototypeOf.es.js';
import rafThrottle_1 from '../../../../node_modules/raf-throttle/lib/rafThrottle.es.js';
import React from 'react';
import { DropdownDialog } from './DropdownDialog.es.js';

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
/**
 * Renders a <Dropdown /> component
 * @param {boolean} open - an optional param - set dropdown to be open/close
 * @param {boolean} trapFocus - set trapFocus property on the dropdown
 * @param {Object} focusTrapOptions - an optional param - set focus on the dropdown
 * @param {boolean} includeA11yCloseButton - set invisible keyboard-focusable button that allows to close the dropdown dialog when open
 * @param {boolean} closeOnOutsideClick - close dropdown on outside click
 * @param {boolean} closeOnEsc - close dropdown on Esc press
 * @param {number} maxHeight - an optional param - set the maxheight on the dropdown
 * @param {number} offsetTop - an optional param - add top margin to the dropdown dialog
 * @param {string} dialogAttachment - an optional param - set dropdown attachment position point
 * @param {string} triggerAttachment - an optional param - trigger attachment position point
 * @param {Array} constraints - an optional param - set dropdown constraints
 * @param {number} dialogZIndex - set the zIndex on the dropdown
 * @param {React.ReactNode} trigger - Accepts a functional component as a dropdown trigger, which receives the `isOpen` state and can trigger opening/closing of the dropdown
 * @param {boolean} matchMenuMinWidthToTrigger - matches the minimum size of the dropdown to what ever element is opening it
 * @param {void} onOpen - an optional param - run a function when dropdown opens
 * @param {void} onClose - an optional param - run a function when dropdown closes
 * @param {string} className - an optional param - set class on dropdown
 * @param {React.ReactNode} children - an optional param - the children to be rendered inside the dropdown
 **/

var Dropdown = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(Dropdown, _React$PureComponent);

  var _super = _createSuper(Dropdown);

  function Dropdown() {
    var _this;

    _classCallCheck(this, Dropdown);

    _this = _super.apply(this, arguments);
    _this._triggerRef = /*#__PURE__*/React.createRef();
    _this.state = {
      open: false
    };

    _this.handleOpen = function () {
      if (_this.props.onOpen) {
        _this.props.onOpen();
      }

      if (!_this.openControlledByProps) {
        _this.setState({
          open: true
        });
      }
    };

    _this.handleClose = function () {
      if (_this.props.onClose) {
        _this.props.onClose();
      }

      if (!_this.openControlledByProps) {
        _this.setState({
          open: false
        });
      }
    };

    _this.handleToggle = function () {
      if (_this.isOpen) {
        _this.handleClose();
      } else {
        _this.handleOpen();
      }
    };

    _this.handleWindowResize = rafThrottle_1(function () {
      if (_this.props.matchMenuMinWidthToTrigger) {
        _this.forceUpdate();
      }
    });
    return _this;
  }

  _createClass(Dropdown, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      window.addEventListener('resize', this.handleWindowResize); // If dropdown on mount is already open,
      // force update it to cause rerender,
      // so the triggerEl is properly passed down to DropdownDialog.

      if (this.isOpen) {
        this.forceUpdate();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.handleWindowResize);
      this.handleWindowResize.cancel();
    }
  }, {
    key: "openControlledByProps",
    get: function get() {
      return this.props.open !== undefined;
    }
  }, {
    key: "isOpen",
    get: function get() {
      if (this.openControlledByProps) {
        return this.props.open;
      }

      return this.state.open;
    }
  }, {
    key: "_triggerEl",
    get: function get() {
      if (!this._triggerRef.current) {
        return undefined;
      }

      return this._triggerRef.current.childNodes[0];
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          trigger = _this$props.trigger,
          children = _this$props.children,
          maxHeight = _this$props.maxHeight,
          offsetTop = _this$props.offsetTop,
          constraints = _this$props.constraints,
          dialogZIndex = _this$props.dialogZIndex,
          includeA11yCloseButton = _this$props.includeA11yCloseButton,
          dialogAttachment = _this$props.dialogAttachment,
          triggerAttachment = _this$props.triggerAttachment,
          closeOnEsc = _this$props.closeOnEsc,
          closeOnOutsideClick = _this$props.closeOnOutsideClick,
          matchMenuMinWidthToTrigger = _this$props.matchMenuMinWidthToTrigger,
          trapFocus = _this$props.trapFocus,
          focusTrapOptions = _this$props.focusTrapOptions,
          className = _this$props.className,
          ariaLabel = _this$props['aria-label'];
      var isOpen = this.isOpen;
      var triggerEl = this._triggerEl;
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
        ref: this._triggerRef
      }, trigger({
        isOpen: isOpen,
        open: this.handleOpen,
        close: this.handleClose,
        toggle: this.handleToggle
      })), triggerEl && /*#__PURE__*/React.createElement(DropdownDialog, {
        className: className,
        open: isOpen,
        triggerEl: triggerEl,
        dialogAttachment: dialogAttachment,
        triggerAttachment: triggerAttachment,
        closeOnEsc: closeOnEsc,
        closeOnOutsideClick: closeOnOutsideClick,
        minWidth: matchMenuMinWidthToTrigger ? triggerEl.offsetWidth : undefined,
        trapFocus: trapFocus,
        focusTrapOptions: focusTrapOptions,
        includeA11yCloseButton: includeA11yCloseButton,
        constraints: constraints,
        zIndex: dialogZIndex,
        onClose: this.handleClose,
        maxHeight: maxHeight,
        offsetTop: offsetTop,
        "aria-label": ariaLabel,
        "data-testid": ariaLabel || 'Dropdown'
      }, children));
    }
  }]);

  return Dropdown;
}(React.PureComponent);
Dropdown.defaultProps = {
  closeOnEsc: true,
  closeOnOutsideClick: true,
  matchMenuMinWidthToTrigger: false,
  trapFocus: true,
  includeA11yCloseButton: true,
  'aria-label': 'Dropdown'
};

export { Dropdown };
